import React from 'react';
import { Platform, View, StyleSheet } from 'react-native';
import { SafeAreaView, } from 'react-native-safe-area-context';
import { theme } from '../theme';
const DEFAULT_EDGES = ['bottom', 'left', 'right'];
export const ContentView = ({ children, style, edges = DEFAULT_EDGES, ...props }) => {
    if (Platform.OS === 'web') {
        return (<View style={[
                { backgroundColor: theme.colors.backgroundScreen },
                styles.container,
                style,
            ]} {...props}>
        {children}
      </View>);
    }
    return (<SafeAreaView edges={edges} style={[
            { backgroundColor: theme.colors.backgroundScreen },
            styles.container,
            style,
        ]} {...props}>
      {children}
    </SafeAreaView>);
};
const styles = StyleSheet.create({
    container: {
        flex: 1,
    },
});
